<template>
  <div v-if="currentRole === 4 || currentRole === 5" class="book-inventory mt-5">
    <h1 class="heading">Inventory Item Statement</h1>
    <div class="d-flex mt-4 ml-0" style="gap: 10px">
      <Autocomplete
        @setFilter="setFilter"
        :styleBorder="'out-lined'"
        placeholder="Select..."
        :keyFilter="header.value"
        :selectedInit="filters['location']"
        :listItem="header.items"
        :announLabel="header.announLabel"
      />
      <v-select class="select-item" v-model="month" :items="listMonth" dense label="Month" outlined>
      </v-select>
      <v-select class="select-item" v-model="year" :items="listYear" dense label="Year" outlined>
      </v-select>
      <v-btn color="primary" @click="SearchData">Search</v-btn>
    </div>
    <template v-if="isLoading">
      <div class="pa-6">
        <v-progress-linear indeterminate color="primary"></v-progress-linear>
      </div>
    </template>
    <v-data-table
      v-if="!isLoading"
      :headers="headers"
      :items="filtered"
      :items-per-page="1000000"
      hide-default-header
      hide-default-footer
      class="elevation-0 mb-5 bookTable"
      fixed-header
      height="79vh"
      id="bookTable"
    >
      <template v-slot:header="{}">
        <thead style="border-radius: 20px; text-align: center" class="v-data-table-header">
          <tr>
            <th
              v-for="(header, index) in headers"
              :key="index"
              :style="{
                background: '#0b2585',
                color: '#fff',
                textAlign: 'center',
                width: `${header.width}`,
                maxWidth: `${header.width}`,
              }"
              v-html="header.text"
            ></th>
          </tr>
        </thead>
        <tr class="fixed-book-filter">
          <th v-for="header in headers" :key="header.text">
            <AutoFilter
              v-if="autoFilters.hasOwnProperty(header.value)"
              @setFilter="setAutoFilter"
              :styleBorder="'border-bottom'"
              :keyFilter="header.value"
              :selectedInit="autoFilters[header.value]"
              :listItem="groupColumnValueList(header.value)"
            />
          </th>
        </tr>
      </template>
      <template v-slot:body="{ items }">
        <tbody v-if="items.length === 0" style="text-align: center">
          <div class="pt-3" style="position: absolute; left: 50%; transform: translate(-50%, 0)">
            No data available
          </div>
        </tbody>
        <tbody v-for="(item, index) in filteredTotal" :key="index">
          <tr class="row-overall">
            <td colspan="4" style="text-align: left !important">
              <v-icon class="mr-5" @click="changeHiddenSup(item.locationID)">{{
                listHidden.includes(item.locationID) ? 'mdi-chevron-up' : 'mdi-chevron-down'
              }}</v-icon>
              <p>Center:</p>
              {{ item.location }}
            </td>
            <td>
              <p>
                {{ item.overallEndQty }}
              </p>
            </td>
          </tr>
          <tr class="row-sale" v-for="(item2, index) in item.purchaseOrd" :key="index">
            <td v-if="listHidden.includes(item2.locationID) === true">
              {{ index + 1 }}
            </td>
            <td v-if="listHidden.includes(item2.locationID) === true">
              {{ item2.productCode }}
            </td>
            <td v-if="listHidden.includes(item2.locationID) === true">
              {{ item2.description }}
            </td>
            <td v-if="listHidden.includes(item2.locationID) === true">
              {{ item2.unit }}
            </td>
            <td v-if="listHidden.includes(item2.locationID) === true">
              {{ item2.endQty }}
            </td>
          </tr>
        </tbody>
        <tfoot v-if="items.length > 0">
          <tr class="bookTableFoot">
            <td class="text-h6" colspan="4" style="text-align: left !important">Grand Total</td>
            <td>
              {{ filteredPayment.overallEndQty.toLocaleString() }}
            </td>
          </tr>
        </tfoot>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { book_management } from '@/api/book_management'
import Autocomplete from '@/components/Utils/AutocompleteAnnoncement.vue'
import AutoFilter from '@/components/Utils/Autocomplete.vue'

export default {
  components: {
    Autocomplete,
    AutoFilter,
  },
  setup() {
    return {}
  },
  data() {
    return {
      isLoading: false,
      header: {},
      currentRole: JSON.parse(localStorage.getItem('currentUser')).userInfo.accountTypeID,
      month: 0,
      year: 0,
      filters: {
        location: [],
      },
      listLocation: [],
      listYear: [],
      listMonth: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      listInventory: [],

      //
      autoFilters: {
        productCode: [],
        description: [],
        endQty: [],
        unit: [],
      },
      //setting table
      headers: [
        { text: 'No', align: 'center', value: 'no', width: '50px', sortable: false },
        {
          text: 'Product Code',
          value: 'productCode',
          width: '200px',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Description',
          value: 'description',
          width: '400px',
          align: 'center',
          sortable: false,
        },
        { text: 'Unit', value: 'unit', align: 'center', width: '100px', sortable: false },
        { text: 'Ending Qty', value: 'endQty', align: 'center', width: '100px', sortable: false },
      ],
      listHidden: [],
    }
  },
  computed: {
    filteredTotal() {
      return this.filtered.map(el => {
        return {
          ...el,
          overallEndQty: el.purchaseOrd.reduce((acc, cur) => acc + cur.endQty, 0),
        }
      })
    },
    filteredPayment() {
      let grandTotal = {
        overallEndQty: 0,
      }
      this.filtered.forEach(el =>
        el.purchaseOrd.forEach(d => {
          grandTotal.overallEndQty += d.endQty
        })
      )
      grandTotal.overallEndQty = Number(grandTotal.overallEndQty.toFixed(0))
      return grandTotal
    },
    filtered() {
      return this.listInventory.map(el => {
        return {
          ...el,
          purchaseOrd: el.purchaseOrd.filter(d => {
            return Object.keys(this.autoFilters).every(f => {
              return this.autoFilters[f].length < 1 || this.autoFilters[f].includes(d[f])
            })
          }),
        }
      })
    },
  },
  created() {
    this.getCenter()
    this.getMonthYear()
    this.init()
  },
  methods: {
    SearchData() {
      this.init()
    },
    changeHiddenSup(subItem) {
      if (this.listHidden.includes(subItem)) {
        this.listHidden = this.listHidden.filter(function (item) {
          return item !== subItem
        })
      } else {
        this.listHidden = [...this.listHidden, subItem]
      }
    },
    /**
     * ? config filter
     */
    setAutoFilter(objectFilterChange) {
      this.autoFilters = {
        ...this.autoFilters,
        [objectFilterChange.name]: objectFilterChange.filter,
      }
    },
    groupColumnValueList(val) {
      let columnVal = []
      this.listInventory.forEach(el => {
        columnVal = [...columnVal, ...el.purchaseOrd]
      })
      return [...new Set(columnVal.map(d => d[val]))]
    },
    /**
     * ? config center autocomplete
     */
    getCenter() {
      this.listLocation = JSON.parse(localStorage.getItem('currentUser')).locationPermissions
      const location = this.getIdArray(
        this.listLocation,
        [parseInt(localStorage.getItem('currentCenter'))],
        'locationID',
        'location'
      )
      this.filters.location = location
      this.header = {
        announLabel: 'Center',
        value: 'location',
        items: this.listLocation.map(el => el.location),
      }
    },
    getIdArray(arr1, arr2, name, id) {
      return arr1.filter(item => arr2.includes(item[name])).map(item => item[id])
    },
    setFilter(objectFilterChange) {
      this.filters = {
        ...this.filters,
        [objectFilterChange.name]: objectFilterChange.filter,
      }
    },

    /**
     * ? Configure set month and Year
     */
    getMonthYear() {
      this.year = new Date().getFullYear()
      this.month = new Date().getMonth() + 1
      for (let i = this.year; i > 2000; i--) {
        this.listYear.push(i)
      }
    },
    async init() {
      this.isLoading = true
      this.listInventory = []
      const locationArr = this.getIdArray(
        this.listLocation,
        this.filters.location,
        'location',
        'locationID'
      )
      const promises = locationArr.map(async el => {
        const res = await book_management.getInventoryItem(el, this.month, this.year)
        if (res.length > 0) {
          const mergedInfo = []
          res.forEach(element => {
            const { location, locationID } = element
            const existingElement = mergedInfo.find(el => el.locationID === locationID)
            delete element.location
            if (existingElement) {
              existingElement.purchaseOrd.push(element)
            } else {
              const newElement = {
                location,
                locationID,
                purchaseOrd: [element],
              }
              mergedInfo.push(newElement)
            }
          })
          const updatedListInventory = [...this.listInventory, mergedInfo[0]].map(el => ({
            ...el,
            location: this.listLocation.find(location => location.locationID === el.locationID)
              ?.location,
          }))
          this.listInventory = updatedListInventory
          this.listInventory.sort((a, b) => a.locationID - b.locationID)
        }
      })
      await Promise.all(promises)
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.book-inventory h1 {
  font-size: 21px;
}

.select-item {
  // margin-right: 10px;
  max-width: 200px;
}
.multiple-select {
  margin-right: 10px;
  max-width: 400px;
}

.book-inventory {
  margin: 0 20px;
}

.fixed-book-filter {
  position: sticky;
  top: 48px;
  z-index: 2;
  background-color: #ffffff;
}
.row-overall {
  td {
    text-align: center;
    p {
      font-weight: bold;
      display: inline-block;
    }
  }
}
.row-sale {
  background: #f3f3f3;
  td {
    text-align: center;
  }
}
.bookTableFoot {
  td {
    text-align: center;
    font-weight: bold;
  }
}
</style>
